import { apiClient } from '@/lib/api-client';
import { API_ROUTES } from '@/lib/api-config';
import type { Faq } from '@/types/faq.types';

/**
 * Get all FAQs
 */
export const getAllFaqs = async (): Promise<Array<Faq>> => {
  return apiClient.get<Array<Faq>>(API_ROUTES.FAQS);
};

/**
 * Get FAQs by type (piercing or tattoo)
 */
export const getFaqsByType = async (type: 'piercing' | 'tattoo'): Promise<Array<Faq>> => {
  return apiClient.get<Array<Faq>>(API_ROUTES.FAQS_BY_TYPE(type));
};

/**
 * Get a single FAQ by ID
 */
export const getFaqById = async (id: string): Promise<Faq> => {
  return apiClient.get<Faq>(API_ROUTES.FAQ_BY_ID(id));
};
